import React from "react";
import PropTypes from "prop-types";
import { Avatar, Box, Container, Link, Typography } from "@mui/material";
import FollowCreator from "../FollowCreator/FollowCreator";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import { LAYOUT } from "../../configuration/theme";
import BackArrow from "../../ui/BackArrow";

const StepButton = ({ href, onClick, label, children }) => (
    <Box
        component={href ? "a" : "button"}
        type={href ? undefined : "button"}
        href={href || undefined}
        disabled={href || onClick ? undefined : true}
        onClick={onClick}
        title={label}
        aria-label={label}
        sx={{
            width: { xs: "32px", md: "38px" },
            height: { xs: "32px", md: "38px" },
            flex: "none",
            alignSelf: "center",
            boxSizing: "border-box",
            padding: 0,
            margin: 0,
            borderRadius: "999px",
            border: "1px solid #E0E0E0",
            backgroundColor: "#fff",
            color: "#111",
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textDecoration: "none",
            cursor: href || onClick ? "pointer" : "default",
            opacity: href || onClick ? 1 : 0.4,
            transition: "border-color 130ms ease",
            "&:hover": {
                border: `1px solid ${href || onClick ? "#000" : "#E0E0E0"}`,
                backgroundColor: "#fff",
                color: "#111",
                textDecoration: "none",
            },
        }}
    >
        {children}
    </Box>
);

const PostHeader = ({ ambassador, avatar, displayName, storefrontUrl, position = 0, total = 0, prevUrl, nextUrl, onPrev, onNext, onClose }) => {
    const onBack = (event) => {
        if (onClose) {
            event.preventDefault();
            onClose();
            return;
        }
        if (window.history.length > 1) {
            event.preventDefault();
            window.history.back();
        }
    };

    return (
        <Box
            sx={{
                borderBottom: "1px solid #EFEFEF",
                backgroundColor: "#fff",
            }}
        >
            <Container sx={{ px: LAYOUT.pagePad, py: "14px" }}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: { xs: "8px", md: "14px" },
                        flexWrap: { xs: "nowrap", md: "wrap" },
                    }}
                >
                    <Box
                        component="a"
                        href={ConfigurationHelper.getGlobalConfiguration().sub_folder || "/"}
                        onClick={onBack}
                        title="Back to posts"
                        sx={{
                            border: 0,
                            background: "transparent",
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            alignSelf: "center",
                            lineHeight: 1,
                            color: "#111",
                            margin: 0,
                            padding: "4px 6px 4px 0",
                            textDecoration: "none",
                            "&:hover": { textDecoration: "none" },
                        }}
                    >
                        <BackArrow />
                    </Box>
                    <Link
                        href={storefrontUrl}
                        underline="none"
                        sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: { xs: "8px", md: "10px" },
                            minWidth: 0,
                            flex: "1 1 auto",
                            overflow: "hidden",
                        }}
                    >
                        <Avatar src={avatar} alt="" sx={{ width: 34, height: 34, flex: "none" }} />
                        <Typography
                            fontSize="15px"
                            fontWeight={700}
                            color="#000"
                            sx={{
                                minWidth: 0,
                                lineHeight: 1.2,
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: { xs: 2, md: 1 },
                                overflow: "hidden",
                                overflowWrap: "anywhere",
                            }}
                        >
                            {displayName}
                        </Typography>
                    </Link>
                    <FollowCreator ambassador={ambassador} displayName={displayName} />
                    <Box
                        sx={{
                            marginLeft: "auto",
                            display: "flex",
                            alignItems: "center",
                            gap: { xs: "6px", md: "8px" },
                            flex: "none",
                        }}
                    >
                        {total > 0 && (
                            <Box
                                component="span"
                                sx={{
                                    fontSize: { xs: "11.5px", md: "12.5px" },
                                    color: "#666666",
                                    marginRight: { xs: "2px", md: "4px" },
                                    lineHeight: 1.2,
                                    textAlign: "right",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {`Post ${position}`}
                                <Box component="span" sx={{ display: { xs: "block", md: "inline" } }}>
                                    {` of ${total}`}
                                </Box>
                            </Box>
                        )}
                        <StepButton href={prevUrl} onClick={onPrev} label="Previous post">
                            &lsaquo;
                        </StepButton>
                        <StepButton href={nextUrl} onClick={onNext} label="Next post">
                            &rsaquo;
                        </StepButton>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};


PostHeader.propTypes = {
    ambassador: PropTypes.object,
    displayName: PropTypes.string,
    storefrontUrl: PropTypes.string,
    position: PropTypes.number,
    total: PropTypes.number,
    prevUrl: PropTypes.string,
    nextUrl: PropTypes.string,
};

export default PostHeader;
